<script>
import { defineComponent } from "vue";
import { mapActions } from "vuex";
import { userApi } from "@/api";
import {accessControlApi} from "@/api/forwriting_index";
import LoadingIcon from "@/components/LoadingIcon.vue";

export default defineComponent({
  name: "Login",
  components: {
    LoadingIcon,
  },
  data() {
    return {
      form: {
        username: "",
        password: "",
        tenant_name: "",
        full_name: "",
        twv_code: "",
      },
      isLoading: false,
      isInvalid: false,
      isTimeOver: false,
      isOtpCodeErr: false,
    };
  },

  methods: {

    ...mapActions(["logIn_forwriting"]),

    async signin() {
      // ==== 1. create data ====
      console.log("form(signin):", this.form);

      try {
        const resp_signin = await accessControlApi.signin(this.form);
        console.log("resp_signin:", resp_signin.data);
        const message = resp_signin.data.message;

        // signin create data 失敗（既存処理維持）
        if (message === "Create data fail and roll back") {
          this.isInvalid = true;
          return;
        }

        // username重複エラーの場合（成功レスポンスだがmessageで失敗判定）
        if (message === "Username already exists") {
          alert(this.$t('SignIn.username_already_exists'));
          this.isInvalid = true;
          return;
        }

        const article_list_id = message.split(":")[1];
        console.log("article_list_id:", article_list_id);

        // ==== 2. log in by new user ====
        this.form.twv_code = "";
        this.isOtpCodeErr = false;
        this.isTimeOver = false;
        this.isInvalid = false;

        this.isLoading = true;
        const username = this.form.username;
        const password = this.form.password;
        try {
          await this.log_in(username, password);
        } catch (error) {
          // 如果登入失敗，錯誤已在 log_in 中處理
          this.isLoading = false;
          return;
        }
        this.isLoading = false;

        // ==== 3. switch to /forwriting/article_lists/.../articles
        const url = `/forwriting/article_lists/${article_list_id}/articles?is_new=true`;
        console.log("url:", url);
        await this.$router.push(url);

      } catch (error) {
        // ★追加修正：エラー内容を丁寧に判定
        console.error("signin error:", error);

        // Axiosが400などのエラーをキャッチするとここに来ます。
        const detail =
          error.response &&
          error.response.data &&
          error.response.data.detail;

        if (detail === "Username already exists") {
          alert(this.$t('SignIn.username_already_exists'));
        } else if (detail === "Create data fail and roll back") {
          alert(this.$t('SignIn.create_data_error'));
        } else {
          // その他すべてのエラーに対する汎用的なメッセージ
          alert(`${this.$t('SignIn.create_data_error')} (Error: ${error.message})`);
        }

        this.isInvalid = true;
        this.isLoading = false;
      }
    },

    async log_in( username, password) {
      console.log( "log_in( )...")

      const User = new FormData();
      User.append("username", username);
      User.append("password", password);

      // Otp認証関連(on pass password)
      const resp = await userApi.isOtpUser( username);
      const isOtpUser = resp.data;
      if (isOtpUser) {
        await this.otpUserCheck(User);
      }
      else {
        try {
          await userApi.loginWithId(User);
        }
        catch (error) {
          console.log("loginWithId() error: ", error);

          switch (error.response?.data?.detail) {
            case "Not White List Ip":
              await this.showIpErrModal();
              return;

            default:
              // 註冊後自動登入失敗時，顯示更友好的錯誤訊息
              this.isInvalid = true;
              this.isLoading = false;
              throw error;
          }
        }

        await this.logIn_forwriting();
        await this.checkAuthenticated();
      }
    },

    async otpUserCheck(User) {
      try {
        await userApi.UserCheck(User);
      }
      catch (error) {
        switch (error.response.data.detail) {
          case "Not White List Ip":
            await this.showIpErrModal();
            break;

          default:
            this.isInvalid = true;
        }
        console.log(error);
        return;
      }
      finally {
        this.isLoading = false;
      }
      document.getElementById("showModalBtn").click();
    },

    async showIpErrModal() {
      document.getElementById("BtnModalClose").click();
      document.getElementById("showIpErrBtn").click();
    },

    async checkAuthenticated() {
      if (!this.$store.getters.isAuthenticated) {
        Object.assign(this.$data, this.$options.data());
        this.isInvalid = true;
      }
      else {
        this.$router.push("/forwriting/article_lists");
      }
    },
  },
})

</script>

<script setup>
</script>

<template>
  <div class="page-wrapper">
    <div class="container d-flex align-items-center justify-content-center">
      <div class="login-container card text-dark bg-light border-dark shadow rounded">

        <div class="card-body" style="text-align: center;margin-top: 20px">

          <h5 style="margin-left: -8px">
            <img src="/img/vectorflux_log_with_name-04.png" alt="..." height="40"
            style="margin-top: -8px"> for Writing
          </h5>

          <p style="margin-top: 30px"><b>{{$t('SignIn.register')}}
            <br>({{$t('SignIn.free_trial')}})</b></p>

          <div class="login-section">
            <LoadingIcon :is-loading="isLoading" />

            <form @submit.prevent="signin" class="needs-validation"
                  style="margin-top: 30px">

              <div class="mb-3">
                <label class="form-label" style="text-align: left">
                  {{$t('SignIn.email')}}:</label>
                <input type="text"
                      :class="{ 'is-invalid': isInvalid }"
                      v-model="form.username"
                      placeholder="Your email address"
                      class="form-control" />

                <div class="invalid-feedback">
                  {{ $t('SignIn.invalid_username_or_password') }}</div>
              </div>

              <div class="mb-3">
                <label for="password" class="form-label" style="text-align: left">
                  {{$t('SignIn.password')}}:</label>
                <input type="password" name="password"
                      v-model="form.password" class="form-control" placeholder="Your password" />
              </div>

              <div class="mb-3">
                <label class="form-label" style="text-align: left">
                  {{ $t('SignIn.company_name') }}:</label>
                <input type="text"
                      v-model="form.tenant_name"
                      :placeholder="$t('SignIn.company_name')"
                      class="form-control" />
              </div>

              <div class="mb-3">
                <label class="form-label" style="text-align: left">
                  {{ $t('SignIn.full_name') }}:</label>
                <input type="text"
                      v-model="form.full_name"
                      :placeholder="$t('SignIn.full_name')"
                      class="form-control" />
              </div>

              <button type="submit" style="margin-top: 30px"
                      class="btn btn-primary btn-submit"
                      :disabled="isLoading">
                {{$t('SignIn.login')}}</button>

            </form>

            <!-- ログインページへのリンク -->
            <div class="mt-3 text-center">
              <p class="mb-2">{{ $t('SignIn.already_have_account') }}</p>
              <router-link to="/forwriting/login">
                {{ $t('SignIn.go_to_login') }}
              </router-link>
            </div>

            <!-- <div class="mt-3 text-center">
              <router-link to="/forwriting/service" class="text-decoration-none">
                サービス詳細を見る
              </router-link>
            </div> -->

          </div>

          <!-- ２段階認証Modal -->
          <button id="showModalBtn" data-bs-toggle="modal" data-bs-target="#OtpModal" style="display:none;"></button>
          <div class="modal fade" id="OtpModal" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1"
               aria-labelledby="staticBackdropLabel" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered">
              <div class="modal-content">
                <div class="modal-header">
                  <h5 class="modal-title" id="OtpModalLabel">{{ $t('LoginView.modal_title') }}</h5>
                  <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                <div class="modal-body">
                  <div class="mb-3">
                    <div>{{ $t('LoginView.otp_msg') }}</div>
                    <br>
                    <label for="OtpCode" class="form-label">{{ $t('LoginView.modal_body') }}</label>
                    <input type="text" name="OtpCode" v-model="form.twv_code" class="form-control" />
                    <br>
                    <div class="text-danger">
                      <p v-if="isOtpCodeErr">{{ $t('LoginView.invalid_otp_code_1') }}</p>
                      <p v-if="isTimeOver">{{ $t('LoginView.invalid_otp_code_2') }}</p>
                    </div>
                  </div>
                </div>
                <div class="modal-footer">
                  <button type="button" id="BtnModalClose" class="btn btn-secondary" data-bs-dismiss="modal">
                    {{ $t('LoginView.close_btn') }}
                  </button>
                  <button type="button" class="btn btn-primary" :disabled="isLoading" @click="checkOtp()">
                    {{ $t('LoginView.send_btn') }}</button>
                </div>
              </div>
            </div>
          </div>

          <!-- IP制限エラー表示Modal -->
          <button id="showIpErrBtn" data-bs-toggle="modal" data-bs-target="#IpErrModal" style="display:none;"></button>
          <div class="modal fade" id="IpErrModal" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1"
               aria-labelledby="staticBackdropLabel" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered">
              <div class="modal-content">
                <div class="modal-header">
                  <h5 class="modal-title" id="IpModalLabel">{{ $t('LoginView.ip_modal_title') }}</h5>
                  <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                <div class="modal-body">
                  <div class="mb-3">
                    <div class="text-danger">
                      <div>{{ $t('LoginView.ip_err_1') }}</div>
                      <div>{{ $t('LoginView.ip_err_2') }}</div>
                    </div>
                  </div>
                </div>
                <div class="modal-footer">
                  <button type="button" id="BtnIpModalClose" class="btn btn-secondary" data-bs-dismiss="modal">
                    Close
                  </button>
                </div>
              </div>
            </div>
          </div>

        </div>

      </div>

    </div>

    <!-- フッター -->
    <footer class="footer py-3 bg-white text-dark border-top">
      <div class="container text-center">
        <div class="d-flex justify-content-center align-items-center gap-4">
          <a href="https://git-house.com/" target="_blank" rel="noopener noreferrer" class="text-decoration-none">
            {{ $t('SignIn.provider') }}
          </a>
          <router-link to="/forwriting/specific-commercial-transaction" class="text-decoration-none">
            {{ $t('SignIn.commercial_transaction') }}
          </router-link>
          <router-link to="/forwriting/privacy-policy" class="text-decoration-none">
            {{ $t('SignIn.privacy_policy') }}
          </router-link>
        </div>
      </div>
    </footer>
  </div>

</template>

<style scoped>
body {
  background-color: #f4f4f4;
}

.login-container {
  min-height: 650px;
  width: min(435px, 92vw);
}

.login-section {
  max-width: 260px;
  width: 100%;
  text-align: center;
  margin: 0 auto;
}

.form-label {
  display: block;
  text-align: left;
  word-break: break-word;
}

.btn-submit {
  margin-top: 10px;
  width: 100%;
}

.page-wrapper {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

.container {
  flex: 1;
}

.footer {
  margin-top: auto;
  width: 100%;
}

.footer a:hover {
  text-decoration: underline !important;
}
</style>